import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { IconButton, Tooltip } from '@mui/material';
import { ReactNode, useEffect, useRef, useState } from "react";
import { Hits, useInstantSearch } from "react-instantsearch";
import { useHistory, useLocation } from "react-router";
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import Cookies from "universal-cookie";
import { CommonService } from "../../Service/CommonService";
import { OrderApiService } from "../../Service/OrderApiService";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import ProductCheckoutPopup from '../popups/ProductCheckoutPopup';
import SignupSuccessPopup from '../popups/SignupSuccessPopup';

//marketplace
import barrel_1_2_a from '../../assets/images/facilities_images/1-2/1_2_a.png';
import barrel_2_3_a from '../../assets/images/facilities_images/2-3/2_3_a.png';
import barrel_3_4_a from '../../assets/images/facilities_images/3-4/3_4_a.png';
import barrel_4_5_a from '../../assets/images/facilities_images/4-5/4_5_a.png';
import barrel_5_6_a from '../../assets/images/facilities_images/5-6/5_6_a.png';
import barrel_6_7_a from '../../assets/images/facilities_images/6-7/6_7_a.png';
import barrel_7_8_a from '../../assets/images/facilities_images/7-8/7_8_a.png';
import barrel_8_9_a from '../../assets/images/facilities_images/8-9/8_9_a.png';
import barrel_9_10_a from '../../assets/images/facilities_images/9-10/9_10_a.png';
import barrel_10_11_a from '../../assets/images/facilities_images/10-11/10_11_a.png';
import barrel_11_12_a from '../../assets/images/facilities_images/11-12/11_12_a.png';
import barrel_12_13_a from '../../assets/images/facilities_images/12-13/12_13_a.png';
import barrel_13_14_a from '../../assets/images/facilities_images/13-14/13_14_a.png';
import barrel_14_15_a from '../../assets/images/facilities_images/14-15/14_15_a.png';
import barrel_15_16_a from '../../assets/images/facilities_images/15-16/15_16_a.png';
import barrel_16_17_a from '../../assets/images/facilities_images/16-17/16_17_a.png';
import barrel_17_18_a from '../../assets/images/facilities_images/17-18/17_18_a.png';
import barrel_18_19_a from '../../assets/images/facilities_images/18-19/18_19_a.png';
import barrel_19_20_a from '../../assets/images/facilities_images/19-20/19_20_a.png';
import barrel_20_21_a from '../../assets/images/facilities_images/20-21/20_21_a.png';
import barrel_21_22_a from '../../assets/images/facilities_images/21-22/21_22_a.png';
import barrel_22_23_a from '../../assets/images/facilities_images/22-23/22_23_a.png';
import barrel_23_24_a from '../../assets/images/facilities_images/23-24/23_24_a.png';
import barrel_24_25_a from '../../assets/images/facilities_images/24-25/24_25_a.png';
import barrel_25_plus_a from '../../assets/images/facilities_images/25_plus/25_plus_a.png';

//wanted to buy
import wanted_to_buy_1_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-1.png';
import wanted_to_buy_2_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-2.png';
import wanted_to_buy_3_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-3.png';
import wanted_to_buy_4_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-4.png';
import wanted_to_buy_5_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-5.png';
import wanted_to_buy_6_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-6.png';
import wanted_to_buy_7_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-7.png';
import wanted_to_buy_8_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-8.png';
import wanted_to_buy_9_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-9.png';
import wanted_to_buy_10_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-10.png';
import wanted_to_buy_11_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-11.png';
import wanted_to_buy_12_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-12.png';
import wanted_to_buy_13_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-13.png';
import wanted_to_buy_14_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-14.png';
import wanted_to_buy_15_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-15.png';
import wanted_to_buy_16_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-16.png';
import wanted_to_buy_17_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-17.png';
import wanted_to_buy_18_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-18.png';
import wanted_to_buy_19_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-19.png';
import wanted_to_buy_20_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-20.png';
import wanted_to_buy_21_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-21.png';
import wanted_to_buy_22_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-22.png';
import wanted_to_buy_23_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-23.png';
import wanted_to_buy_24_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-24.png';
import wanted_to_buy_25_plus_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-25.png';

import EditIconWhite from '../../assets/images/icons/EditIconWhite.svg';
interface SearchContainerProps {
  children?: ReactNode;
  isShowAssociatedCompanies?: boolean;
  isShowViewMyListingsCompanies?: boolean;
  collectionName?: any;
}

const HitsContainer: React.FC<SearchContainerProps> = ({ children, isShowAssociatedCompanies, isShowViewMyListingsCompanies, collectionName }) => {
  const { status } = useInstantSearch();
  const userId = new Cookies().get('userId');
  const [wishlistItems, setWishlistItems] = useState<any[]>([]);
  const [soldBarrels, setSoldBarrels] = useState([]);
  const [showHits, setShowHits] = useState(false);
  const [globalFilter, setGlobalFilter] = useState<string>('');
  const location = useLocation();
  const currentPath = location.pathname;
  const companyId = new Cookies().get('companyId');
  const imageCacheRef = useRef({});
  const usedImagesPerAge = {};

  useEffect(() => {
    if(CommonService.isUserLoggedIn()) {
        getUserWishlist();
    }
  }, []);

  const addToWishList = async (itemId: string, productName: string): Promise<boolean> => {
    const wishListRequest = {
        inventoryId: itemId,
        userId: userId,
        inventoryTitle: productName
    };

    try {
        const response: any = await OrderApiService.addToWishlist(wishListRequest);
        getUserWishlist();
        return true
    } catch (error) {
        console.error('Error while adding wishlist data:', error);
        if(error?.response?.data?.errorMessage == 'This inventory is no longer available in marketplace') {
            CommonService.Toast.fire({
                title: "This inventory is no longer available in Marketplace",
                icon: "error",
            });
        } 
        return false
    }
};

const getUserWishlist = async () => {
  try {
      const response: any = await OrderApiService.getUserWishlist(userId);
      setWishlistItems(response.data);
  } catch (error) {
      console.error('Error while fetching wishlist:', error);
  }
};

const removeFromWishList = async (itemId: string): Promise<boolean> => {
  const wishListRequest = {
      inventoryId: itemId,
      userId: userId,
  };

  try {
      const response: any = await OrderApiService.removeFromWishlist(wishListRequest);
      getUserWishlist();
      return true;
  } catch (error) {
      console.error('Error while removing wishlist data:', error);
      return false;
  }
};

const getAllSoldInventoryWishList = async() => {
    try {
        const response = await OrderApiService.getAllSoldInventoryWishList(CommonService.getUserId());
        setSoldBarrels(response.data);
    } catch (error) {
        console.error('Error while fetching barrel availability:', error);
        return false; // Return false in case of an error
    }
};

  useEffect(() => {

    if(status !== "loading" && status !== "stalled")
      setShowHits(true);
    else
      setShowHits(false);
  
  }, [status]);

  useEffect(() => {

    let filters = userId;
    if (currentPath === '/user/inventories') {
      if(isShowViewMyListingsCompanies) {
        filters = userId ? [`company_id:=${companyId}`] : ['company_id'];
      } else {
        filters = userId ? [`company_id:!=${companyId}`] : ['company_id'];
      }
    }else if (currentPath === '/user/wanted-to-buy') {
      if(isShowViewMyListingsCompanies) {
        filters = [`company_id:=${companyId}`];
      } 
    } else if (currentPath === '/user/my-inventory') {
        filters = userId ? [`company_id:=${companyId}`] : ['company_id'];
    } else if (currentPath === '/user/wish-list') {
        filters = wishlistItems.length > 0 ? [`owner_id:!=${userId}`, `(inventory_id:${wishlistItems.join(' || inventory_id:')})`] : [`owner_id:!=${userId}  &&  inventory_id:null`];
        if(CommonService.isUserLoggedIn()) {
             getAllSoldInventoryWishList();
        }
    }

    // Generate dynamic filter string
    const filterValue = Array.isArray(filters) ? filters?.join(' && ').replace(/\\/g, '') : filters;
    setGlobalFilter(filterValue);

}, [location.pathname, wishlistItems, isShowViewMyListingsCompanies]);

  const barrelImages: string[] = [
    barrel_1_2_a, barrel_2_3_a, barrel_3_4_a, barrel_4_5_a, barrel_5_6_a,
    barrel_6_7_a, barrel_7_8_a, barrel_8_9_a, barrel_9_10_a, barrel_10_11_a,
    barrel_11_12_a, barrel_12_13_a, barrel_13_14_a, barrel_14_15_a, barrel_15_16_a,
    barrel_16_17_a, barrel_17_18_a, barrel_18_19_a, barrel_19_20_a, barrel_20_21_a,
    barrel_21_22_a, barrel_22_23_a, barrel_23_24_a, barrel_24_25_a, barrel_25_plus_a
  ];

  const wantedToBuyImages: string[] = [
    wanted_to_buy_1_a, wanted_to_buy_2_a, wanted_to_buy_3_a, wanted_to_buy_4_a, wanted_to_buy_5_a,
    wanted_to_buy_6_a, wanted_to_buy_7_a, wanted_to_buy_8_a, wanted_to_buy_9_a, wanted_to_buy_10_a,
    wanted_to_buy_11_a, wanted_to_buy_12_a, wanted_to_buy_13_a, wanted_to_buy_14_a, wanted_to_buy_15_a,
    wanted_to_buy_16_a, wanted_to_buy_17_a, wanted_to_buy_18_a, wanted_to_buy_19_a, wanted_to_buy_20_a,
    wanted_to_buy_21_a, wanted_to_buy_22_a, wanted_to_buy_23_a, wanted_to_buy_24_a, wanted_to_buy_25_plus_a
  ];

  const getAgeIndex = (years: number, months: number = 0): number => {
    const age = years + months / 12;
    let index = Math.floor(age) - 1; // Map 1-2 → index 0, 2-3 → index 1, etc.

    if (index < 0) index = 0;
    if (index >= barrelImages.length) index = barrelImages.length - 1; // 25+
    return index;
  };

  const getWantedToBuyImage = (ageFrom: number): string => {
    let age = Math.floor(ageFrom);

    // cap at 25+
    if (age >= 25) {
      return wantedToBuyImages[wantedToBuyImages.length - 1];
    }

    // 2 → index 1 → wanted_to_buy_2_a
    return wantedToBuyImages[Math.max(age - 1, 0)];
  };

  const getBarrelImage = (age: number, hitId?: string): string => {
    const ageIndex = getAgeIndex(age);
    return barrelImages[ageIndex];
  };

   return showHits ? (
    <Hits
      hitComponent={(props) => {
        const hit = props.hit;

        let ageInYears = 0;
        let isWantedToBuy = false;

        // -------------------------------------------
        // 1. If age_from and age_to exist → use them
        // -------------------------------------------
        if (hit.age_from != null && hit.age_to != null) {
          isWantedToBuy = true;

          let ageList: number[] = [];
          let startSteps = Math.round(hit.age_from * 2);
          let endSteps = Math.round(hit.age_to * 2);

          for (let step = startSteps; step <= endSteps; step++) {
            ageList.push(step / 2);
          }

          ageInYears = ageList[Math.floor(Math.random() * ageList.length)];
          console.log("Selected Age (Wanted to Buy):", ageInYears);
        }
        
        // ------------------------------------------------
        // 2. Otherwise → calculate from fill_date_timestamp
        // ------------------------------------------------
        else {
          const { years, months } = CommonService.calculateAge(hit.fill_date_timestamp);
          ageInYears = Number(years) + Number(months || 0) / 12;
        }

        // 3. Now get correct image using ageInYears
        const imageSrc = isWantedToBuy
          ? getWantedToBuyImage(hit.age_from)
          : getBarrelImage(ageInYears, hit.objectID);

        // 4. Render result
        return (
          <GridHitItem
            {...props}
            imageSrc={imageSrc}
            ageInYears={ageInYears}
            addToWishList={addToWishList}
            removeFromWishList={removeFromWishList}
            wishlistItems={wishlistItems}
            soldBarrelDetails={soldBarrels}
            isShowAssociatedCompanies={isShowAssociatedCompanies}
            isShowViewMyListingsCompanies={isShowViewMyListingsCompanies}
            collectionName={collectionName}
          />
        );
      }}
      classNames={{
        emptyRoot: "my-empty-class",
      }}
    />
  ) : (
    <div></div> // Or a loader if preferred
  );
  
};

const GridHitItem: React.FC<{ hit: any, imageSrc:any, ageInYears:any, addToWishList: (itemId: string, productName:string) => Promise<Boolean>, removeFromWishList: (itemId: string) => Promise<Boolean>, wishlistItems: any[], soldBarrelDetails:any[], isShowAssociatedCompanies, isShowViewMyListingsCompanies, collectionName}> = ({ hit, imageSrc, ageInYears, addToWishList, removeFromWishList, wishlistItems,soldBarrelDetails,isShowAssociatedCompanies, isShowViewMyListingsCompanies, collectionName}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const history = useHistory();
  const [isInWishlist, setIsInWishlist] = useState(wishlistItems.includes(hit.inventory_id));
  const { years, months } = CommonService.calculateAge(hit.fill_date_timestamp);
  const [isShowProductCheckoutPopup, setShowProductCheckoutPopup] = useState(false);
  const [isShowAccountUnderReviewPopup, setShowAccountUnderReviewPopup] = useState(false);

  const handleRowClick = () => {

    //check user login or not 
    if(!CommonService.isUserLoggedIn()) {
        CommonService.getSignupStatus() ? setShowAccountUnderReviewPopup(true): setShowProductCheckoutPopup(true);
        return;
    }
    // Redirect to another page with the hit id
    // Row only clickable for users 
    if(collectionName == process.env.REACT_APP_TYPESENSE_WANTED_TO_BUY_COLLECTIONNAME){
      if(CommonService.isUser()) {
        history.push(`/user/wanted-to-buy-product-details/${hit.id}`);
      } else {
        history.push(`/master/wanted-to-buy-product-details/${hit.id}`);
      }
    }else{
      if(CommonService.isUser()) {
        history.push(`/user/product-details/${hit.id}`);
      } else {
        history.push(`/master/product-details/${hit.id}`);
      }
    }
  };

  const handleCancelPopup = () => {
    setShowProductCheckoutPopup(false);
    setShowAccountUnderReviewPopup(false);
  }

  const handleConfirmPopup = () => {
    history.push(`/login`);
  }

 
  const manageWishList = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      event.stopPropagation();

       // Restrict access to Super Admins and users belonging to the same company as the inventory
        if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
          return ;
        }

       //if user is not loggedIn then show the checkout popup for login
      if(!CommonService.isUserLoggedIn()) {
        CommonService.getSignupStatus() ? setShowAccountUnderReviewPopup(true): setShowProductCheckoutPopup(true);
        return;
      }
      if (isInWishlist) {
        const success = await removeFromWishList(hit.inventory_id);
        if (success) {
          setIsInWishlist(false);
        }
      } else {
        const success = await addToWishList(hit.inventory_id, hit.productName);
        if (success) {
          setIsInWishlist(true);
        }
      }
  };

  useEffect(() => {
      console.log("these are my sold container" + soldBarrelDetails);
  }, []);

  const handleEditSellRequest = (customerServiceRequestId:any) => {
    history.push(`${CommonService.isUser() ? '/user' : '/master'}` + `/edit-customer-service-request/${customerServiceRequestId}`);
  }

  function handleEditServiceRequest(id: any) {
    throw new Error('Function not implemented.');
  }

  return (
    <>
      <div className="grid-view inventory__grid-view" onClick={handleRowClick}>
        <div className="grid-item">
          <div className="card bg-transparent">
            <div className='card-img-wrapper'>
              <img
                src={imageSrc}
                alt={`Whisky Barrel aged ${ageInYears} years`}
                className="card-img-top"
              />

              {/* Start (Hide This My Listing On Conditionally) */}
              {CommonService.getCompanyId() == hit.company_id && hit?.customer_service_request_id && CommonService.isUser() && (
                <>
                 <div className='my-listing-wrapper'>
                   <span className='text'>My Listing</span>
                   <span className='img-wrapper' 
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditSellRequest(hit?.customer_service_request_id)
                      }
                      }>
                      <Tooltip title="Edit My Listing" arrow>
                        <img
                          src={EditIcon}
                          className="cursor-pointer"
                          alt="EditIcon"
                          height={13}
                        />
                      </Tooltip>
                   </span>
                  </div>
                </>
              )}
              {/* End */}
            </div>
            {collectionName == process.env.REACT_APP_TYPESENSE_COLLECTIONNAME && <div className="card-body">
              <div className="card-title">
                <h5>
                  {hit.product_name}
                  {/* <span>{hit.mash_bill}</span> */}
                </h5>
              </div>
              <div className="card-text d-flex justify-content-between">
                <div className="grid-cell">
                  <CurrencyFormatter
                    amount={hit.price}
                    locale="en-US"
                    currency="USD"
                  />
                  <span>/ Container</span>
                </div>
                {(currentPath === "/user/inventories" ||
                  currentPath === "/master/inventories" ||
                  currentPath === "/user/wish-list") && (
                  <div className="grid-cell" onClick={manageWishList}>
                    {isInWishlist ? (
                      <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Remove from Wishlist')} arrow>
                        <FavoriteIcon
                          sx={{ cursor: "pointer", color: "red" }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title = {CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Add to Wishlist')} arrow>
                        <FavoriteBorderIcon
                          sx={{ cursor: "pointer", color: "#D9D9D9" }}
                        />
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
              {isShowAssociatedCompanies && CommonService.isAdmin() && hit?.customer_service_request_id && (
                <>
                  {hit?.company_name && <div className="card-text d-flex justify-content-between">
                    <div className="grid-cell">
                      {/* <span> */}
                      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.875 15.425H15.75V7.55005C15.75 7.25168 15.6315 6.96553 15.4205 6.75455C15.2095 6.54357 14.9234 6.42505 14.625 6.42505H10.125V3.05005C10.1251 2.84633 10.0699 2.64639 9.96533 2.47159C9.86071 2.29678 9.71059 2.15366 9.53098 2.05751C9.35138 1.96136 9.14904 1.91578 8.94556 1.92563C8.74208 1.93549 8.54509 2.00042 8.37563 2.11349L2.75062 5.86255C2.59632 5.9655 2.46986 6.10501 2.38252 6.26866C2.29517 6.43231 2.24965 6.61502 2.25 6.80052V15.425H1.125C0.975816 15.425 0.832742 15.4843 0.727252 15.5898C0.621763 15.6953 0.5625 15.8384 0.5625 15.9875C0.5625 16.1367 0.621763 16.2798 0.727252 16.3853C0.832742 16.4908 0.975816 16.55 1.125 16.55H16.875C17.0242 16.55 17.1673 16.4908 17.2727 16.3853C17.3782 16.2798 17.4375 16.1367 17.4375 15.9875C17.4375 15.8384 17.3782 15.6953 17.2727 15.5898C17.1673 15.4843 17.0242 15.425 16.875 15.425ZM14.625 7.55005V15.425H10.125V7.55005H14.625ZM3.375 6.80052L9 3.05005V15.425H3.375V6.80052ZM7.875 8.67505V9.80005C7.875 9.94923 7.81574 10.0923 7.71025 10.1978C7.60476 10.3033 7.46168 10.3625 7.3125 10.3625C7.16332 10.3625 7.02024 10.3033 6.91475 10.1978C6.80926 10.0923 6.75 9.94923 6.75 9.80005V8.67505C6.75 8.52586 6.80926 8.38279 6.91475 8.2773C7.02024 8.17181 7.16332 8.11255 7.3125 8.11255C7.46168 8.11255 7.60476 8.17181 7.71025 8.2773C7.81574 8.38279 7.875 8.52586 7.875 8.67505ZM5.625 8.67505V9.80005C5.625 9.94923 5.56574 10.0923 5.46025 10.1978C5.35476 10.3033 5.21168 10.3625 5.0625 10.3625C4.91332 10.3625 4.77024 10.3033 4.66475 10.1978C4.55926 10.0923 4.5 9.94923 4.5 9.80005V8.67505C4.5 8.52586 4.55926 8.38279 4.66475 8.2773C4.77024 8.17181 4.91332 8.11255 5.0625 8.11255C5.21168 8.11255 5.35476 8.17181 5.46025 8.2773C5.56574 8.38279 5.625 8.52586 5.625 8.67505ZM5.625 12.6125V13.7375C5.625 13.8867 5.56574 14.0298 5.46025 14.1353C5.35476 14.2408 5.21168 14.3 5.0625 14.3C4.91332 14.3 4.77024 14.2408 4.66475 14.1353C4.55926 14.0298 4.5 13.8867 4.5 13.7375V12.6125C4.5 12.4634 4.55926 12.3203 4.66475 12.2148C4.77024 12.1093 4.91332 12.05 5.0625 12.05C5.21168 12.05 5.35476 12.1093 5.46025 12.2148C5.56574 12.3203 5.625 12.4634 5.625 12.6125ZM7.875 12.6125V13.7375C7.875 13.8867 7.81574 14.0298 7.71025 14.1353C7.60476 14.2408 7.46168 14.3 7.3125 14.3C7.16332 14.3 7.02024 14.2408 6.91475 14.1353C6.80926 14.0298 6.75 13.8867 6.75 13.7375V12.6125C6.75 12.4634 6.80926 12.3203 6.91475 12.2148C7.02024 12.1093 7.16332 12.05 7.3125 12.05C7.46168 12.05 7.60476 12.1093 7.71025 12.2148C7.81574 12.3203 7.875 12.4634 7.875 12.6125Z" fill="#9E874A" />
                      </svg>
                      {/* </span>  */}
                      <span className='company-name'>{hit?.company_name}</span> {/* Please Add Account Owner Name Here Now It Is Static please remove this when making dynamic */}

                    </div>
                    <div className="grid-cell">
                      <Tooltip title="Edit" arrow>
                        <IconButton
                          aria-label="message"
                          size="small"
                          sx={{
                            borderRadius: "50%", backgroundColor: ' #D9D9D9B2', color: "#1C1B1F", padding: "8px"
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditSellRequest(hit?.customer_service_request_id)
                          }
                          }
                        >
                          <img className="cursor-pointer"
                            src={EditIcon}
                            alt="EditIcon"
                            height={12}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>}
                </>
              )}
              <div className="details"> 
                <div className="grid-cell">
                  {/* <span> */}
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5688 13.0848L9.09313 8.7998L13.5688 4.5148C13.5713 4.51194 13.574 4.50923 13.5769 4.50668C13.7166 4.36683 13.8118 4.18869 13.8504 3.99477C13.8889 3.80085 13.8691 3.59985 13.7934 3.41718C13.7178 3.23451 13.5897 3.07837 13.4253 2.96848C13.261 2.85859 13.0677 2.7999 12.87 2.7998H3.87001C3.67235 2.80002 3.47918 2.85881 3.31491 2.96874C3.15065 3.07868 3.02264 3.23483 2.94707 3.41747C2.8715 3.60012 2.85175 3.80106 2.89031 3.99492C2.92888 4.18878 3.02403 4.36687 3.16376 4.50668L3.17126 4.5148L7.64688 8.7998L3.17126 13.0848L3.16376 13.0929C3.02403 13.2327 2.92888 13.4108 2.89031 13.6047C2.85175 13.7986 2.8715 13.9995 2.94707 14.1821C3.02264 14.3648 3.15065 14.5209 3.31491 14.6309C3.47918 14.7408 3.67235 14.7996 3.87001 14.7998H12.87C13.0678 14.7998 13.2611 14.7412 13.4256 14.6314C13.59 14.5215 13.7182 14.3654 13.794 14.1827C13.8697 14 13.8895 13.799 13.851 13.605C13.8125 13.411 13.7173 13.2328 13.5775 13.0929C13.5744 13.0904 13.5715 13.0877 13.5688 13.0848ZM12.87 3.7998L8.37001 8.1073L3.87001 3.7998H12.87ZM3.87001 13.7998L8.37001 9.4923L12.87 13.7998H3.87001Z" fill="#9E874A"/>
                    </svg>

                  {/* </span>  */}
                  <span>
                    {years} years {months} months
                  </span>
                  {/* <span>{hit.fill_date_timestamp}</span> */}
                  {/* <span>Years Old</span> */}
                </div>
              </div>
              {hit.mash_bill?.toUpperCase() !== "UNKNOWN" && (<div className="details">
                <div className="grid-cell">
                  {/* <span> */}
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.1094 4.04495C10.854 4.04495 10.6008 4.09132 10.3629 4.18167C10.0273 3.50492 9.34922 3.16859 9.31828 3.15355C9.29223 3.14088 9.2635 3.13428 9.23438 3.13428C9.20525 3.13428 9.17652 3.14088 9.15047 3.15355C9.1193 3.16859 8.44148 3.50492 8.10586 4.18167C7.86795 4.09132 7.61479 4.04495 7.35938 4.04495C7.30965 4.04495 7.26196 4.06416 7.22679 4.09835C7.19163 4.13253 7.17188 4.1789 7.17188 4.22725V6.05016C7.17188 6.58198 7.38917 7.09201 7.77597 7.46806C8.16276 7.84411 8.68737 8.05537 9.23438 8.05537C9.78138 8.05537 10.306 7.84411 10.6928 7.46806C11.0796 7.09201 11.2969 6.58198 11.2969 6.05016V4.22725C11.2969 4.1789 11.2771 4.13253 11.242 4.09835C11.2068 4.06416 11.1591 4.04495 11.1094 4.04495ZM9.04688 7.68076C8.63454 7.63544 8.25377 7.44419 7.97714 7.14348C7.70051 6.84276 7.54736 6.4536 7.54688 6.05016V5.69561C7.95921 5.74093 8.33998 5.93217 8.61661 6.23289C8.89324 6.53361 9.04639 6.92277 9.04688 7.32621V7.68076ZM9.04688 6.17458C8.87492 5.9363 8.65168 5.73728 8.39265 5.59133C8.13362 5.44539 7.84501 5.35601 7.54688 5.32943V4.41956C7.95921 4.46489 8.33998 4.65613 8.61661 4.95685C8.89324 5.25756 9.04639 5.64673 9.04688 6.05016V6.17458ZM8.44102 4.34369C8.65711 3.90596 9.06 3.62979 9.23438 3.52565C9.40875 3.63001 9.81164 3.90619 10.0275 4.34369C9.68087 4.55224 9.40504 4.85536 9.23438 5.21527C9.06369 4.8553 8.78777 4.55217 8.44102 4.34369ZM10.9219 6.05016C10.9214 6.4536 10.7682 6.84276 10.4916 7.14348C10.215 7.44419 9.83421 7.63544 9.42188 7.68076V7.32621C9.42236 6.92277 9.57551 6.53361 9.85214 6.23289C10.1288 5.93217 10.5095 5.74093 10.9219 5.69561V6.05016ZM10.9219 5.32943C10.6237 5.35601 10.3351 5.44539 10.0761 5.59133C9.81707 5.73728 9.59383 5.9363 9.42188 6.17458V6.05016C9.42236 5.64673 9.57551 5.25756 9.85214 4.95685C10.1288 4.65613 10.5095 4.46489 10.9219 4.41956V5.32943Z" fill="#9E874A"/>
                      <path d="M13.5479 0.700195C14.1526 0.700397 14.602 1.31128 14.4346 1.91699L14.4355 1.91797L12.3623 10.042C12.7936 10.2688 13.0859 10.7479 13.0859 11.2998V13.4873C13.0859 14.2741 12.5121 14.8992 11.7617 14.8994H6.0459C5.32214 14.8994 4.7207 14.2756 4.7207 13.4873V11.2998C4.7207 10.7414 5.04302 10.2337 5.50488 10.0078L5.21387 6.58691H3.3916C2.76868 6.58681 2.27148 6.04366 2.27148 5.39355V1.89355C2.27148 1.24345 2.76868 0.700296 3.3916 0.700195H13.5479ZM6.0459 10.5244C5.64822 10.5244 5.3291 10.8562 5.3291 11.2998V13.4873C5.3291 13.9309 5.64822 14.2627 6.0459 14.2627H11.7617C12.1592 14.2625 12.4775 13.9308 12.4775 13.4873V11.2998C12.4775 10.8564 12.1592 10.5246 11.7617 10.5244H6.0459ZM8.90332 11.4189C9.42425 11.4189 9.82031 11.8528 9.82031 12.3936C9.82031 12.9343 9.42425 13.3682 8.90332 13.3682C8.38245 13.3681 7.9873 12.9343 7.9873 12.3936C7.9873 11.8528 8.38245 11.419 8.90332 11.4189ZM8.90332 12.0557C8.73535 12.0557 8.59473 12.1961 8.59473 12.3936C8.59473 12.591 8.73535 12.7314 8.90332 12.7314C9.07134 12.7314 9.21191 12.591 9.21191 12.3936C9.21191 12.1961 9.07134 12.0557 8.90332 12.0557ZM6.1123 9.8877H11.7852L12.5322 6.90039C12.5329 6.89719 12.5331 6.89484 12.5332 6.89453C12.5345 6.88874 12.5362 6.88203 12.5381 6.875C12.5419 6.86059 12.5467 6.84151 12.5527 6.82031C12.5649 6.7778 12.5807 6.72334 12.5967 6.66992C12.6127 6.61631 12.6286 6.56295 12.6406 6.52344C12.6465 6.50403 12.6518 6.48798 12.6553 6.47656C12.657 6.47092 12.6582 6.46596 12.6592 6.46289C12.6596 6.46135 12.6599 6.45978 12.6602 6.45898V6.45801L13.3174 3.8584C13.3177 3.85626 13.3184 3.85453 13.3184 3.85449C13.3186 3.85338 13.3192 3.8524 13.3193 3.85156C13.3207 3.84508 13.324 3.83114 13.3281 3.81348C13.3366 3.77696 13.35 3.7189 13.3643 3.6582C13.3786 3.59741 13.3938 3.5331 13.4053 3.48438C13.411 3.46013 13.4155 3.43927 13.4189 3.4248C13.4206 3.41788 13.4219 3.41209 13.4229 3.4082C13.4233 3.40625 13.4246 3.40433 13.4248 3.40332V3.40137L13.4258 3.39941L13.8564 1.76562C13.8988 1.53859 13.7512 1.33711 13.5479 1.33691H5.38867L6.1123 9.8877ZM3.3916 1.33691C3.12158 1.33702 2.87891 1.58676 2.87891 1.89355V5.39355C2.87891 5.70035 3.12158 5.95009 3.3916 5.9502H5.17188L4.77832 1.33691H3.3916ZM13.3232 3.83789L13.4199 3.8623C13.4113 3.89638 13.4214 3.85508 13.4375 3.78613C13.4201 3.78044 13.4023 3.77785 13.3877 3.7793C13.368 3.78773 13.3432 3.80695 13.3369 3.81445C13.3292 3.82477 13.3253 3.83467 13.3252 3.83496C13.3247 3.83609 13.3236 3.83691 13.3232 3.83789ZM13.3213 3.84277C13.3209 3.84389 13.3214 3.84541 13.3213 3.8457C13.3212 3.84589 13.3211 3.84431 13.3223 3.83984C13.3218 3.84124 13.3214 3.84231 13.3213 3.84277Z" fill="#9E874A" stroke="#9E874A" stroke-width="0.2"/>
                    </svg>
                  {/* </span>  */}
                  <span>{hit.mash_bill}</span>
                </div>
              </div>
              )}
              {hit.proof != '0' && (<div className="details">
                <div className="grid-cell">
                  {/* <span> */}
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.8537 13.2854L9.99806 6.8573V3.2998H10.4981C10.6307 3.2998 10.7578 3.24713 10.8516 3.15336C10.9454 3.05959 10.9981 2.93241 10.9981 2.7998C10.9981 2.6672 10.9454 2.54002 10.8516 2.44625C10.7578 2.35248 10.6307 2.2998 10.4981 2.2998H5.49806C5.36545 2.2998 5.23828 2.35248 5.14451 2.44625C5.05074 2.54002 4.99806 2.6672 4.99806 2.7998C4.99806 2.93241 5.05074 3.05959 5.14451 3.15336C5.23828 3.24713 5.36545 3.2998 5.49806 3.2998H5.99806V6.8573L2.14244 13.2854C2.0515 13.437 2.00238 13.61 2.00008 13.7868C1.99779 13.9636 2.04239 14.1378 2.12936 14.2917C2.21632 14.4456 2.34253 14.5738 2.49514 14.663C2.64774 14.7523 2.82127 14.7995 2.99806 14.7998H12.9981C13.175 14.7998 13.3488 14.7528 13.5016 14.6637C13.6545 14.5746 13.781 14.4465 13.8682 14.2925C13.9554 14.1386 14.0001 13.9642 13.9979 13.7873C13.9957 13.6103 13.9466 13.4372 13.8556 13.2854H13.8537ZM6.92681 7.25293C6.97357 7.17542 6.99822 7.08658 6.99806 6.99605V3.2998H8.99806V6.99605C8.99791 7.08658 9.02255 7.17542 9.06931 7.25293L11.4581 11.2373C10.7081 11.3854 9.64119 11.3229 8.22369 10.6054C7.22931 10.1023 6.28306 9.83543 5.39744 9.8048L6.92681 7.25293ZM2.99806 13.7998L4.78181 10.8261C5.67244 10.7173 6.67619 10.9417 7.77056 11.4961C8.95806 12.0967 9.95806 12.3011 10.7706 12.3011C11.1838 12.3029 11.5952 12.2461 11.9924 12.1323L12.9981 13.7998H2.99806Z" fill="#9E874A"/>
                    </svg>
                  {/* </span>  */}
                  <span>
                    {CommonService.formatToSingleDecimal(hit.proof)}{" "}
                    {hit.proof_unit
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word: string) =>
                          word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}
                  </span>
                </div>
              </div>)}
            </div>
            }
            {collectionName == process.env.REACT_APP_TYPESENSE_WANTED_TO_BUY_COLLECTIONNAME && <div className="card-body">
              <div className="card-title">
                <h5>
                  {hit.product_name}
                  {/* <span>{hit.mash_bill}</span> */}
                </h5>
              </div>
              <div className="card-text d-flex justify-content-between">
                <div className="grid-cell">
                  <CurrencyFormatter
                    amount={hit.tentative_price}
                    locale="en-US"
                    currency="USD"
                  />
                  <span>/ {hit.container_type}</span>
                </div>
                {(currentPath === "/user/inventories" ||
                  currentPath === "/master/inventories" ||
                  currentPath === "/user/wish-list") && (
                  <div className="grid-cell" onClick={manageWishList}>
                    {isInWishlist ? (
                      <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Remove from Wishlist')} arrow>
                        <FavoriteIcon
                          sx={{ cursor: "pointer", color: "red" }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title = {CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Add to Wishlist')} arrow>
                        <FavoriteBorderIcon
                          sx={{ cursor: "pointer", color: "#D9D9D9" }}
                        />
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
              {isShowAssociatedCompanies && CommonService.isAdmin() && hit?.customer_service_request_id && (
                <>
                  {hit?.company_name && <div className="card-text d-flex justify-content-between">
                    <div className="grid-cell">
                      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.875 15.425H15.75V7.55005C15.75 7.25168 15.6315 6.96553 15.4205 6.75455C15.2095 6.54357 14.9234 6.42505 14.625 6.42505H10.125V3.05005C10.1251 2.84633 10.0699 2.64639 9.96533 2.47159C9.86071 2.29678 9.71059 2.15366 9.53098 2.05751C9.35138 1.96136 9.14904 1.91578 8.94556 1.92563C8.74208 1.93549 8.54509 2.00042 8.37563 2.11349L2.75062 5.86255C2.59632 5.9655 2.46986 6.10501 2.38252 6.26866C2.29517 6.43231 2.24965 6.61502 2.25 6.80052V15.425H1.125C0.975816 15.425 0.832742 15.4843 0.727252 15.5898C0.621763 15.6953 0.5625 15.8384 0.5625 15.9875C0.5625 16.1367 0.621763 16.2798 0.727252 16.3853C0.832742 16.4908 0.975816 16.55 1.125 16.55H16.875C17.0242 16.55 17.1673 16.4908 17.2727 16.3853C17.3782 16.2798 17.4375 16.1367 17.4375 15.9875C17.4375 15.8384 17.3782 15.6953 17.2727 15.5898C17.1673 15.4843 17.0242 15.425 16.875 15.425ZM14.625 7.55005V15.425H10.125V7.55005H14.625ZM3.375 6.80052L9 3.05005V15.425H3.375V6.80052ZM7.875 8.67505V9.80005C7.875 9.94923 7.81574 10.0923 7.71025 10.1978C7.60476 10.3033 7.46168 10.3625 7.3125 10.3625C7.16332 10.3625 7.02024 10.3033 6.91475 10.1978C6.80926 10.0923 6.75 9.94923 6.75 9.80005V8.67505C6.75 8.52586 6.80926 8.38279 6.91475 8.2773C7.02024 8.17181 7.16332 8.11255 7.3125 8.11255C7.46168 8.11255 7.60476 8.17181 7.71025 8.2773C7.81574 8.38279 7.875 8.52586 7.875 8.67505ZM5.625 8.67505V9.80005C5.625 9.94923 5.56574 10.0923 5.46025 10.1978C5.35476 10.3033 5.21168 10.3625 5.0625 10.3625C4.91332 10.3625 4.77024 10.3033 4.66475 10.1978C4.55926 10.0923 4.5 9.94923 4.5 9.80005V8.67505C4.5 8.52586 4.55926 8.38279 4.66475 8.2773C4.77024 8.17181 4.91332 8.11255 5.0625 8.11255C5.21168 8.11255 5.35476 8.17181 5.46025 8.2773C5.56574 8.38279 5.625 8.52586 5.625 8.67505ZM5.625 12.6125V13.7375C5.625 13.8867 5.56574 14.0298 5.46025 14.1353C5.35476 14.2408 5.21168 14.3 5.0625 14.3C4.91332 14.3 4.77024 14.2408 4.66475 14.1353C4.55926 14.0298 4.5 13.8867 4.5 13.7375V12.6125C4.5 12.4634 4.55926 12.3203 4.66475 12.2148C4.77024 12.1093 4.91332 12.05 5.0625 12.05C5.21168 12.05 5.35476 12.1093 5.46025 12.2148C5.56574 12.3203 5.625 12.4634 5.625 12.6125ZM7.875 12.6125V13.7375C7.875 13.8867 7.81574 14.0298 7.71025 14.1353C7.60476 14.2408 7.46168 14.3 7.3125 14.3C7.16332 14.3 7.02024 14.2408 6.91475 14.1353C6.80926 14.0298 6.75 13.8867 6.75 13.7375V12.6125C6.75 12.4634 6.80926 12.3203 6.91475 12.2148C7.02024 12.1093 7.16332 12.05 7.3125 12.05C7.46168 12.05 7.60476 12.1093 7.71025 12.2148C7.81574 12.3203 7.875 12.4634 7.875 12.6125Z" fill="#9E874A" />
                      </svg>
                      <span className='company-name'>{hit?.company_name}</span> {/* Please Add Account Owner Name Here Now It Is Static please remove this when making dynamic */}

                    </div>
                    <div className="grid-cell">
                      <Tooltip title="Edit" arrow>
                        <IconButton
                          aria-label="message"
                          size="small"
                          sx={{
                            borderRadius: "50%", backgroundColor: ' #D9D9D9B2', color: "#1C1B1F", padding: "8px"
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditSellRequest(hit?.customer_service_request_id)
                          }
                          }
                        >
                          <img className="cursor-pointer"
                            src={EditIcon}
                            alt="EditIcon"
                            height={12}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>}
                </>
              )}
              <div className="details"> 
                <div className="grid-cell">
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5688 13.0848L9.09313 8.7998L13.5688 4.5148C13.5713 4.51194 13.574 4.50923 13.5769 4.50668C13.7166 4.36683 13.8118 4.18869 13.8504 3.99477C13.8889 3.80085 13.8691 3.59985 13.7934 3.41718C13.7178 3.23451 13.5897 3.07837 13.4253 2.96848C13.261 2.85859 13.0677 2.7999 12.87 2.7998H3.87001C3.67235 2.80002 3.47918 2.85881 3.31491 2.96874C3.15065 3.07868 3.02264 3.23483 2.94707 3.41747C2.8715 3.60012 2.85175 3.80106 2.89031 3.99492C2.92888 4.18878 3.02403 4.36687 3.16376 4.50668L3.17126 4.5148L7.64688 8.7998L3.17126 13.0848L3.16376 13.0929C3.02403 13.2327 2.92888 13.4108 2.89031 13.6047C2.85175 13.7986 2.8715 13.9995 2.94707 14.1821C3.02264 14.3648 3.15065 14.5209 3.31491 14.6309C3.47918 14.7408 3.67235 14.7996 3.87001 14.7998H12.87C13.0678 14.7998 13.2611 14.7412 13.4256 14.6314C13.59 14.5215 13.7182 14.3654 13.794 14.1827C13.8697 14 13.8895 13.799 13.851 13.605C13.8125 13.411 13.7173 13.2328 13.5775 13.0929C13.5744 13.0904 13.5715 13.0877 13.5688 13.0848ZM12.87 3.7998L8.37001 8.1073L3.87001 3.7998H12.87ZM3.87001 13.7998L8.37001 9.4923L12.87 13.7998H3.87001Z" fill="#9E874A"/>
                    </svg>
                  <span>
                    {hit.age_from} years {hit.age_to} years
                  </span>
                </div>
              </div>
              {hit.mash_bill && <div className="details">
                <div className="grid-cell">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.1094 4.04495C10.854 4.04495 10.6008 4.09132 10.3629 4.18167C10.0273 3.50492 9.34922 3.16859 9.31828 3.15355C9.29223 3.14088 9.2635 3.13428 9.23438 3.13428C9.20525 3.13428 9.17652 3.14088 9.15047 3.15355C9.1193 3.16859 8.44148 3.50492 8.10586 4.18167C7.86795 4.09132 7.61479 4.04495 7.35938 4.04495C7.30965 4.04495 7.26196 4.06416 7.22679 4.09835C7.19163 4.13253 7.17188 4.1789 7.17188 4.22725V6.05016C7.17188 6.58198 7.38917 7.09201 7.77597 7.46806C8.16276 7.84411 8.68737 8.05537 9.23438 8.05537C9.78138 8.05537 10.306 7.84411 10.6928 7.46806C11.0796 7.09201 11.2969 6.58198 11.2969 6.05016V4.22725C11.2969 4.1789 11.2771 4.13253 11.242 4.09835C11.2068 4.06416 11.1591 4.04495 11.1094 4.04495ZM9.04688 7.68076C8.63454 7.63544 8.25377 7.44419 7.97714 7.14348C7.70051 6.84276 7.54736 6.4536 7.54688 6.05016V5.69561C7.95921 5.74093 8.33998 5.93217 8.61661 6.23289C8.89324 6.53361 9.04639 6.92277 9.04688 7.32621V7.68076ZM9.04688 6.17458C8.87492 5.9363 8.65168 5.73728 8.39265 5.59133C8.13362 5.44539 7.84501 5.35601 7.54688 5.32943V4.41956C7.95921 4.46489 8.33998 4.65613 8.61661 4.95685C8.89324 5.25756 9.04639 5.64673 9.04688 6.05016V6.17458ZM8.44102 4.34369C8.65711 3.90596 9.06 3.62979 9.23438 3.52565C9.40875 3.63001 9.81164 3.90619 10.0275 4.34369C9.68087 4.55224 9.40504 4.85536 9.23438 5.21527C9.06369 4.8553 8.78777 4.55217 8.44102 4.34369ZM10.9219 6.05016C10.9214 6.4536 10.7682 6.84276 10.4916 7.14348C10.215 7.44419 9.83421 7.63544 9.42188 7.68076V7.32621C9.42236 6.92277 9.57551 6.53361 9.85214 6.23289C10.1288 5.93217 10.5095 5.74093 10.9219 5.69561V6.05016ZM10.9219 5.32943C10.6237 5.35601 10.3351 5.44539 10.0761 5.59133C9.81707 5.73728 9.59383 5.9363 9.42188 6.17458V6.05016C9.42236 5.64673 9.57551 5.25756 9.85214 4.95685C10.1288 4.65613 10.5095 4.46489 10.9219 4.41956V5.32943Z" fill="#9E874A"/>
                      <path d="M13.5479 0.700195C14.1526 0.700397 14.602 1.31128 14.4346 1.91699L14.4355 1.91797L12.3623 10.042C12.7936 10.2688 13.0859 10.7479 13.0859 11.2998V13.4873C13.0859 14.2741 12.5121 14.8992 11.7617 14.8994H6.0459C5.32214 14.8994 4.7207 14.2756 4.7207 13.4873V11.2998C4.7207 10.7414 5.04302 10.2337 5.50488 10.0078L5.21387 6.58691H3.3916C2.76868 6.58681 2.27148 6.04366 2.27148 5.39355V1.89355C2.27148 1.24345 2.76868 0.700296 3.3916 0.700195H13.5479ZM6.0459 10.5244C5.64822 10.5244 5.3291 10.8562 5.3291 11.2998V13.4873C5.3291 13.9309 5.64822 14.2627 6.0459 14.2627H11.7617C12.1592 14.2625 12.4775 13.9308 12.4775 13.4873V11.2998C12.4775 10.8564 12.1592 10.5246 11.7617 10.5244H6.0459ZM8.90332 11.4189C9.42425 11.4189 9.82031 11.8528 9.82031 12.3936C9.82031 12.9343 9.42425 13.3682 8.90332 13.3682C8.38245 13.3681 7.9873 12.9343 7.9873 12.3936C7.9873 11.8528 8.38245 11.419 8.90332 11.4189ZM8.90332 12.0557C8.73535 12.0557 8.59473 12.1961 8.59473 12.3936C8.59473 12.591 8.73535 12.7314 8.90332 12.7314C9.07134 12.7314 9.21191 12.591 9.21191 12.3936C9.21191 12.1961 9.07134 12.0557 8.90332 12.0557ZM6.1123 9.8877H11.7852L12.5322 6.90039C12.5329 6.89719 12.5331 6.89484 12.5332 6.89453C12.5345 6.88874 12.5362 6.88203 12.5381 6.875C12.5419 6.86059 12.5467 6.84151 12.5527 6.82031C12.5649 6.7778 12.5807 6.72334 12.5967 6.66992C12.6127 6.61631 12.6286 6.56295 12.6406 6.52344C12.6465 6.50403 12.6518 6.48798 12.6553 6.47656C12.657 6.47092 12.6582 6.46596 12.6592 6.46289C12.6596 6.46135 12.6599 6.45978 12.6602 6.45898V6.45801L13.3174 3.8584C13.3177 3.85626 13.3184 3.85453 13.3184 3.85449C13.3186 3.85338 13.3192 3.8524 13.3193 3.85156C13.3207 3.84508 13.324 3.83114 13.3281 3.81348C13.3366 3.77696 13.35 3.7189 13.3643 3.6582C13.3786 3.59741 13.3938 3.5331 13.4053 3.48438C13.411 3.46013 13.4155 3.43927 13.4189 3.4248C13.4206 3.41788 13.4219 3.41209 13.4229 3.4082C13.4233 3.40625 13.4246 3.40433 13.4248 3.40332V3.40137L13.4258 3.39941L13.8564 1.76562C13.8988 1.53859 13.7512 1.33711 13.5479 1.33691H5.38867L6.1123 9.8877ZM3.3916 1.33691C3.12158 1.33702 2.87891 1.58676 2.87891 1.89355V5.39355C2.87891 5.70035 3.12158 5.95009 3.3916 5.9502H5.17188L4.77832 1.33691H3.3916ZM13.3232 3.83789L13.4199 3.8623C13.4113 3.89638 13.4214 3.85508 13.4375 3.78613C13.4201 3.78044 13.4023 3.77785 13.3877 3.7793C13.368 3.78773 13.3432 3.80695 13.3369 3.81445C13.3292 3.82477 13.3253 3.83467 13.3252 3.83496C13.3247 3.83609 13.3236 3.83691 13.3232 3.83789ZM13.3213 3.84277C13.3209 3.84389 13.3214 3.84541 13.3213 3.8457C13.3212 3.84589 13.3211 3.84431 13.3223 3.83984C13.3218 3.84124 13.3214 3.84231 13.3213 3.84277Z" fill="#9E874A" stroke="#9E874A" stroke-width="0.2"/>
                    </svg>
                  <span>{hit.mash_bill}</span>
                </div>
              </div>}
              <div className="details">
                <div className="grid-cell">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.8537 13.2854L9.99806 6.8573V3.2998H10.4981C10.6307 3.2998 10.7578 3.24713 10.8516 3.15336C10.9454 3.05959 10.9981 2.93241 10.9981 2.7998C10.9981 2.6672 10.9454 2.54002 10.8516 2.44625C10.7578 2.35248 10.6307 2.2998 10.4981 2.2998H5.49806C5.36545 2.2998 5.23828 2.35248 5.14451 2.44625C5.05074 2.54002 4.99806 2.6672 4.99806 2.7998C4.99806 2.93241 5.05074 3.05959 5.14451 3.15336C5.23828 3.24713 5.36545 3.2998 5.49806 3.2998H5.99806V6.8573L2.14244 13.2854C2.0515 13.437 2.00238 13.61 2.00008 13.7868C1.99779 13.9636 2.04239 14.1378 2.12936 14.2917C2.21632 14.4456 2.34253 14.5738 2.49514 14.663C2.64774 14.7523 2.82127 14.7995 2.99806 14.7998H12.9981C13.175 14.7998 13.3488 14.7528 13.5016 14.6637C13.6545 14.5746 13.781 14.4465 13.8682 14.2925C13.9554 14.1386 14.0001 13.9642 13.9979 13.7873C13.9957 13.6103 13.9466 13.4372 13.8556 13.2854H13.8537ZM6.92681 7.25293C6.97357 7.17542 6.99822 7.08658 6.99806 6.99605V3.2998H8.99806V6.99605C8.99791 7.08658 9.02255 7.17542 9.06931 7.25293L11.4581 11.2373C10.7081 11.3854 9.64119 11.3229 8.22369 10.6054C7.22931 10.1023 6.28306 9.83543 5.39744 9.8048L6.92681 7.25293ZM2.99806 13.7998L4.78181 10.8261C5.67244 10.7173 6.67619 10.9417 7.77056 11.4961C8.95806 12.0967 9.95806 12.3011 10.7706 12.3011C11.1838 12.3029 11.5952 12.2461 11.9924 12.1323L12.9981 13.7998H2.99806Z" fill="#9E874A"/>
                    </svg>
                  <span>
                    {CommonService.formatToSingleDecimal(hit.proofing_min)}{" "} - {CommonService.formatToSingleDecimal(hit.proofing_max)}{" "}
                    {hit.proof_unit
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word: string) =>
                          word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}
                  </span>
                </div>
              </div>
            </div>}
          </div>
        </div>
      </div>

      {isShowProductCheckoutPopup && (
        <ProductCheckoutPopup
          onCancel={handleCancelPopup}
          onConfirm={handleConfirmPopup}
        />
      )}

      {isShowAccountUnderReviewPopup && (
        <SignupSuccessPopup
          onBrowseMarketPlace={handleCancelPopup}
          onCancel={handleCancelPopup}
          type="PENDING_REVIEW"
        />
      )}
    </>
  );
}

export default HitsContainer;
